import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import { SwiperSlide } from "swiper/react";
import { fetchHiredlyXContent } from "../../../redux/actions/company_action";
import {
  CarouselContainer,
  CompanyButtons,
  LogoContainer,
  LogoStyled,
  SwiperStyled,
  TrustedCompanyGrid,
} from "./styles";

let query = `
    logoCarouselTop {
      brandLogo {
        data {
          attributes {
            url
          }
        }
      }
      clickThroughURL
    }
`;

let query2 = `
    logoCarouselBottom {
      brandLogo {
        data {
          attributes {
            url
          }
        }
      }
      clickThroughURL
    }
`;

const swiperSettings = {
  modules: [Autoplay],
  loop: true,
  slidesPerView: 3,
  spaceBetween: 30,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  speed: 3000,
  breakpoints: {
    480: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    600: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 25,
    },
    1280: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    1281: {
      slidesPerView: 6,
      spaceBetween: 15,
    },
  },
};

const reverseSwiperSettings = {
  modules: [Autoplay],
  loop: true,
  slidesPerView: 3,
  spaceBetween: 30,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    reverseDirection: true,
  },
  speed: 3000,
  breakpoints: {
    480: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    600: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 25,
    },
    1280: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    1281: {
      slidesPerView: 6,
      spaceBetween: 15,
    },
  },
};

export default function HXLandingCompanies(props) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [firstRowCompanies, setFirstRowCompanies] = useState([]);
  const [secondRowCompanies, setSecondRowCompanies] = useState([]);
  const isTablet = useMediaQuery("(max-width:768px)");
  const isMobile = useMediaQuery("(max-width:600px)");

  async function fetchData() {
    const response1 = await dispatch(fetchHiredlyXContent(query));
    const response2 = await dispatch(fetchHiredlyXContent(query2));

    setFirstRowCompanies(response1?.logoCarouselTop || []);
    setSecondRowCompanies(response2?.logoCarouselBottom || []);

    setLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) return;

  return (
    <TrustedCompanyGrid
      container
      justifyContent={"center"}
      flexDirection={"column"}
      alignItems={"center"}
    >
      <>
        <CarouselContainer container justifyContent={"center"}>
          <SwiperStyled {...swiperSettings}>
            {firstRowCompanies.map((company, index) => (
              <SwiperSlide key={index}>
                <CompanyButtons
                  href={
                    company.clickThroughURL !== "-"
                      ? company.clickThroughURL
                      : undefined
                  }
                  target={
                    company.clickThroughURL !== "-" ? "_blank" : undefined
                  }
                  rel={company.clickThroughURL !== "-" ? "noopener" : undefined}
                  disabled={company.clickThroughURL === "-"}
                >
                  <LogoContainer>
                    <LogoStyled
                      alt={
                        company?.brandLogo?.data?.attributes?.alternativeText ??
                        `company-logo-${index}`
                      }
                      src={company?.brandLogo?.data?.attributes?.url}
                    />
                  </LogoContainer>
                </CompanyButtons>
              </SwiperSlide>
            ))}
          </SwiperStyled>
        </CarouselContainer>

        {secondRowCompanies.length > 0 && (
          <CarouselContainer container justifyContent={"center"}>
            <SwiperStyled {...reverseSwiperSettings}>
              {secondRowCompanies.map((company, index) => (
                <SwiperSlide key={index}>
                  <CompanyButtons
                    href={
                      company.clickThroughURL !== "-"
                        ? company.clickThroughURL
                        : undefined
                    }
                    target={
                      company.clickThroughURL !== "-" ? "_blank" : undefined
                    }
                    rel={
                      company.clickThroughURL !== "-" ? "noopener" : undefined
                    }
                    disabled={company.clickThroughURL === "-"}
                  >
                    <LogoContainer>
                      <LogoStyled
                        alt={
                          company?.brandLogo?.data?.attributes
                            ?.alternativeText ?? `company-logo-${index}`
                        }
                        src={company?.brandLogo?.data?.attributes?.url}
                      />
                    </LogoContainer>
                  </CompanyButtons>
                </SwiperSlide>
              ))}
            </SwiperStyled>
          </CarouselContainer>
        )}
      </>
    </TrustedCompanyGrid>
  );
}
